import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import OutputTextField from 'components/atoms/GefMui/OutputTextField';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { FIELDS } from 'features/views/contactHistory/communicationInfo/form';
import { getSelectedGroup } from 'features/views/contactHistory/selectors';
import { equalOrThreeDashes, fromIsoDate, fromIsoTime } from 'utils';
import { joinString } from 'utils/string';

export const CommunicationInfo = () => {
	const communicationGroup = useSelector(getSelectedGroup);

	if (!communicationGroup) return null;

	const {
		representativeSurname,
		representativeFirstname,
		partnerName,
		distributionChannelText,
		channelText,
		communicationStart,
		communicationEnd,
		workplaceAddress,
	} = communicationGroup;

	const worker = joinString(' ', [representativeSurname, representativeFirstname]);

	const distributionChannel =
		distributionChannelText && workplaceAddress
			? joinString(' - ', [distributionChannelText, workplaceAddress])
			: distributionChannelText || workplaceAddress;

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('contactHistory:communicationInfoHeader')} />
				<Grid container>
					<Grid size={12}>
						<Grid container spacing={2}>
							<Grid size={8}>
								<OutputTextField
									size="small"
									id={FIELDS.client}
									label={getLabelMessage('contactHistory:client')}
									fullWidth
									value={equalOrThreeDashes(partnerName)}
									slotProps={{
										inputLabel: {
											shrink: !!partnerName,
										},
									}}
								/>
							</Grid>
							<Grid size={4}>
								<OutputTextField
									size="small"
									id={FIELDS.contactType}
									label={getLabelMessage('contactHistory:contactType')}
									fullWidth
									value={equalOrThreeDashes(channelText)}
									slotProps={{
										inputLabel: {
											shrink: !!channelText,
										},
									}}
								/>
							</Grid>
							<Grid size={8}>
								<OutputTextField
									size="small"
									id={FIELDS.worker}
									label={getLabelMessage('contactHistory:worker')}
									fullWidth
									value={equalOrThreeDashes(worker)}
									slotProps={{
										inputLabel: {
											shrink: !!worker,
										},
									}}
								/>
							</Grid>
							<Grid size={2}>
								<OutputTextField
									size="small"
									id={FIELDS.creationDateFrom}
									label={getLabelMessage('contactHistory:creationDateFrom')}
									fullWidth
									value={equalOrThreeDashes(fromIsoDate(communicationStart))}
									slotProps={{
										inputLabel: {
											shrink: !!communicationStart,
										},
									}}
								/>
							</Grid>
							<Grid size={2}>
								<OutputTextField
									size="small"
									id={FIELDS.creationDateTo}
									label={getLabelMessage('contactHistory:creationDateTo')}
									fullWidth
									value={equalOrThreeDashes(fromIsoDate(communicationEnd))}
									slotProps={{
										inputLabel: {
											shrink: !!communicationEnd,
										},
									}}
								/>
							</Grid>
							<Grid size={8}>
								<OutputTextField
									size="small"
									id={FIELDS.distributionChannel}
									label={getLabelMessage('contactHistory:distributionChannel')}
									fullWidth
									value={equalOrThreeDashes(distributionChannel)}
									slotProps={{
										inputLabel: {
											shrink: !!distributionChannel,
										},
									}}
								/>
							</Grid>
							<Grid size={2}>
								<OutputTextField
									size="small"
									id={FIELDS.creationTimeFrom}
									label={getLabelMessage('contactHistory:creationTimeFrom')}
									fullWidth
									value={equalOrThreeDashes(fromIsoTime(communicationStart))}
									slotProps={{
										inputLabel: {
											shrink: !!communicationStart,
										},
									}}
								/>
							</Grid>
							<Grid size={2}>
								<OutputTextField
									size="small"
									id={FIELDS.creationTimeTo}
									label={getLabelMessage('contactHistory:creationTimeTo')}
									fullWidth
									value={equalOrThreeDashes(fromIsoTime(communicationEnd))}
									slotProps={{
										inputLabel: {
											shrink: !!communicationEnd,
										},
									}}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Stack>
		</Paper>
	);
};

export default CommunicationInfo;
